import { FC } from "react";
import { LucideIcon } from "lucide-react-native";

import { VnBox } from "@/components/VnBox";
import { VnIcon } from "@/components/VnIcon";
import { VnText } from "@/components/VnText/VnText";
import { I18nKeyType } from "@/i18n";

type IconAndTextPropsType = {
  icon: LucideIcon;
  textI18nKey: I18nKeyType | I18nKeyType[];
  textI18nOptions?: object;
  iconClassName?: string;
};

export const IconAndText: FC<IconAndTextPropsType> = ({
  icon,
  textI18nKey,
  textI18nOptions,
  iconClassName,
}) => (
  <VnBox className="flex w-full flex-row items-center gap-4">
    <VnIcon as={icon} size={36} className={iconClassName} />
    <VnText
      variant="lgBold"
      className="text-muted-foreground"
      i18nKey={textI18nKey}
      i18nOptions={textI18nOptions}
    />
  </VnBox>
);
